import {
  SegmentCategories,
  SegmentCategoriesFactory
} from "cookiesConsent/infrastructure/segment/SegmentCategories"

type CategoriesListener = (categories: SegmentCategories) => void

export class ConsentBus {
  private current: SegmentCategories
  private readonly seed: SegmentCategories
  private readonly listeners: Set<CategoriesListener>

  constructor(seed: SegmentCategories) {
    this.current = seed
    this.seed = seed
    this.listeners = new Set()
  }

  snapshot = (): SegmentCategories => this.current

  reset = (): void => {
    this.current = this.seed
    this.listeners.clear()
  }

  publish = (next: SegmentCategories): void => {
    if (this.current.equals(next)) {
      this.ignore()
    } else {
      this.current = next
      this.listeners.forEach(notify => notify(next))
    }
  }

  private ignore = (): void => {}

  subscribe = (listener: CategoriesListener): (() => void) => {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }
}

export const consentBus = new ConsentBus(
  new SegmentCategoriesFactory().necessaryOnly()
)
